import {AbstractDictionaryViewModel} from "./abstract-dictionary.view-model";
import {ModelApiModel} from "../../api/models/model.api-model";

export class ModelViewModel extends AbstractDictionaryViewModel<ModelApiModel> {
  constructor(protected apiModel: ModelApiModel) {
    super(apiModel);
  }
}
